import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { Attachment, AttachmentData } from "src/util/types/dataModels/attachment"

//region Types

export type AttachmentDocument = RxDocument<Attachment>
export type AttachmentCollection = RxCollection<Attachment>
export type AttachmentDataCollection = RxCollection<AttachmentData>

//endregion

/**
 * Schema for attachment collections
 */
export const attachmentSchema: RxJsonSchema<Attachment> = {
  title: "Attachment schema",
  description: "Attachments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    name: { type: "string", maxLength: 255 },
    extension: { type: "string" },
    description: { type: "string" },
    size: { type: "number", final: true },
    state: { type: "number", minimum: -1, maximum: 2 },
    state_reason: { type: "string" },
    context: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  attachments: { encrypted: false },
  required: ["id", "name"],
}

export const attachmentDataSchema: RxJsonSchema<AttachmentData> = {
  title: "Attachment schema",
  description: "Attachments Data",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { ref: "attachments", type: "string", maxLength: 36, uniqueItems: true },
    path: { type: "string" },
    type: { type: "string" },
  },
  attachments: { encrypted: false },
  required: ["id", "path", "type"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const attachmentCollectionCreator: RxCollectionCreator = {
  schema: attachmentSchema,
}

export const attachmentDataCollectionCreator: RxCollectionCreator = {
  schema: attachmentDataSchema,
}
